import JustValidate from 'just-validate';

const newsletterBlock = document.getElementById('newsletter');
const newsletterSubmit = document.getElementById('newsletterSubmit');
const newsletterForm = document.getElementById('newsletterForm');

if (newsletterForm) {


    const validate = new JustValidate(
        '#newsletterForm',
        {
            errorFieldCssClass: 'is-invalid',
            errorLabelCssClass: 'is-label-invalid',
            errorLabelStyle: {},
            focusInvalidField: true,
            validateBeforeSubmitting: true,
        },
    );

    validate.addField('#newsletterEmailField', [
        {
            rule: 'required',
            errorMessage: "Pole jest wymagane"
        },
        {
            rule: 'email',
            errorMessage: "Nieprawidłowy adres e-mail",
        }
    ]);

    validate.addField('#newsletterAcceptance', [
        {
            rule: 'required',
            errorMessage: "Pole jest wymagane"
        },
    ]);

    validate.addRequiredGroup('.newsletter-block__checkbox-list', 'Wybierz co namniej 1 temat');

    validate.onFail((fields, groups) => {
        for (const [key, value] of Object.entries(groups)) {
            if (value.isValid === false) {
                value.groupElem.scrollIntoView({ behavior: 'auto' })
            }
        }
    });

    validate.onSuccess((event) => {
        newsletterForm.classList.add('freshmail_form_1');
        newsletterSubmit.removeAttribute('disabled');
        const $newsletterForm = $('#newsletterForm');

        // Code from Freshmail
        var fm_form_id = '.freshmail_form_' + $newsletterForm.find('input[name=fm_form_id]').val();

        var btn_val = $newsletterForm.find('button.form_subscribe_button').html();
        $(fm_form_id).find('button.form_subscribe_button').html("Wysyłanie...");
        $(fm_form_id).find('button.form_subscribe_button').css("opacity", "0.6");
        $(fm_form_id).find('button.form_subscribe_button').attr("disabled", "disabled");
        $.post(static_var.ajax, $newsletterForm.serialize(), function (data) {
            var obj = $.parseJSON(data);
            $(fm_form_id).find('button.form_subscribe_button').html(btn_val);
            $(fm_form_id).find('button.form_subscribe_button').css("opacity", "1");
            $(fm_form_id).find('button.form_subscribe_button').removeAttr("disabled");
            if (obj.status == "success") {
                $(fm_form_id).html('<span class="message_' + obj.status + '">' + obj.message + '</span>');
                if (obj.redirect != 0 && obj.code != '1304') {
                    setTimeout(function () {
                        document.location = obj.redirect;
                    }, 2000);
                }
            }
            if (obj.status == "error") {
                $('.message_error').remove();
                $(fm_form_id).prepend('<span class="message_' + obj.status + '">' + obj.message + '</span>');
            }
        });

        setTimeout(() => {
            newsletterBlock.scrollIntoView({
                'behavior': 'smooth'
            })
        }, 1000);

        return false;
    })
}
